import { Button } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import importSuccess from "../../assets/svg/icons/import-success.svg";
import upload from "../../assets/svg/icons/upload.svg";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

const ConvertLeadSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const count = location?.state?.prompt;

  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-mt-12 tw-pt-12">
      <img src={importSuccess} alt="" />
      <div className="tw-text-2xl tw-font-semibold tw-text-text-primary tw-mt-6">
        Leads imported successfully
      </div>
      <div className="tw-text-lg tw-text-sub-text">
        {count} new lead(s) have been added to your account
      </div>
      <div className="tw-flex tw-items-center tw-gap-5 tw-mt-12">
        <Button
          className="theme-btn"
          type="primary"
          onClick={() => navigate("/search-lead")}
        >
          <EyeOutlined /> View Leads
        </Button>
        <Button
          className="!tw-bg-white tw-px-4 !tw-text-sub-text tw-shadow-none !tw-text-xs !tw-font-semibold tw-border tw-border-solid tw-border-border-secondary tw-rounded-[10px]"
          type="primary"
          onClick={() => {
            searchParams.delete("status");
            navigate(`${location.pathname}?${searchParams.toString()}`);
          }}
        >
          <img src={upload} alt="" /> Import other leads
        </Button>
      </div>
    </div>
  );
};

export default ConvertLeadSuccess;
